import { render, staticRenderFns } from "./RegisterAffiliate.vue?vue&type=template&id=b61ed5e4"
import script from "./RegisterAffiliate.vue?vue&type=script&lang=ts"
export * from "./RegisterAffiliate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports